import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/restaurant";
import { useOrderCapture } from "@/components/OrderCapture";

export default function WhatsAppFab() {
  const { requestOrder } = useOrderCapture();
  return (
    <button
      type="button"
      onClick={() => requestOrder(waLink())}
      aria-label="Order on WhatsApp"
      data-testid="whatsapp-fab"
      className="pulse-ring fixed bottom-6 right-6 z-50 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 hover:scale-110 transition-transform"
    >
      <MessageCircle size={24} />
    </button>
  );
}
